import React from 'react';

/**
 * One candidate in an association picker: what it is on the left, what you can
 * do about it on the right. `action` is a slot because a row is not always
 * actionable -- a workspace another client holds shows a badge instead.
 */
export const PickerRow = ({
  name,
  detail,
  badge,
  action
}: {
  name: string;
  detail?: string | null;
  badge?: React.ReactNode;
  action: React.ReactNode;
}) => (
  <li className="flex items-center justify-between gap-4 py-3">
    <div className="min-w-0">
      <p className="truncate text-sm font-medium text-neutral-900 dark:text-neutral-100">{name}</p>
      {detail && (
        <p className="mt-0.5 truncate text-xs text-neutral-500 dark:text-neutral-400">{detail}</p>
      )}
    </div>
    <div className="flex shrink-0 items-center gap-2">
      {badge}
      {action}
    </div>
  </li>
);

/**
 * A labelled group of picker rows, for a picker with more than one kind of
 * candidate. A single-source picker lists rows directly.
 */
export const PickerSection = ({
  heading,
  children
}: {
  heading: string;
  children: React.ReactNode;
}) => (
  <div className="pt-2 first:pt-0">
    <p className="pb-1 text-xs font-medium uppercase tracking-wide text-neutral-500 dark:text-neutral-400">
      {heading}
    </p>
    <ul className="divide-y divide-neutral-200 dark:divide-neutral-700">{children}</ul>
  </div>
);
